import { TPositionMap } from './types'

export const iconPositionMap: TPositionMap = {
  START: 'flex-start',
  END: 'flex-end',
  CENTER: 'center',
}
